var map = {
	"./about/locales/fa/about.ts": "5550",
	"./auth/locales/fa/auth.ts": "eebc",
	"./auth/locales/fa/fields.ts": "be50",
	"./blog/locales/fa/blog.ts": "71e1",
	"./contact/locales/fa/contact.ts": "9b3f",
	"./dashboard/locales/fa/dashboard.ts": "80e5",
	"./faq/locales/fa/faq.ts": "a08e",
	"./home/locales/fa/home.ts": "7f3a",
	"./products/locales/fa/products.ts": "6fed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4b07";